import {Breadcrumb, Spin} from 'antd';
import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {Link, useLocation, useParams} from 'react-router-dom';

import {RqGetAllProducts} from '../../reactQuery/apis';

import {selectAuth} from './../../redux/selectors/authSelector';
import ImageSection from './ImageSection/ImageSection';
import ProductInformation from './ProductInformation/ProductInformation';
import RelatedProducts from './RelatedProducts/RelatedProducts';

const ProductDetails = () => {
  const {id} = useParams();
  const location = useLocation();

  const auth = useSelector(selectAuth);
  const token = auth?.tokenData;

  const {data: allProducts, isLoading, error} = RqGetAllProducts(token);

  const product =
    location.state?.product ||
    allProducts?.find(p => String(p.id) === String(id));

  const [selectedColor, setSelectedColor] = useState(null);

  useEffect(() => {
    if (product?.variants?.length && !selectedColor) {
      setSelectedColor(product.variants[0].color);
    }
  }, [product, selectedColor]);

  if (isLoading) {return <Spin />;}
  if (error) {return <div>Error: {error.message}</div>;}
  if (!product) {return <div>Product not found</div>;}

  const relatedProducts = allProducts?.filter(
    item =>
      item.category === product.category &&
      item.id !== product.id,
  );

  const breadcrumbItems = [
    {title: <Link to={'/'}>Home</Link>},
    {title: <Link to={'/product'}>Products</Link>},
    {title: product.productName},
  ];

  return (
    <div className={'flex flex-col justify-center items-center lg:px-20 lg:py-10 w-full'}>
      <div className={'w-full max-w-6xl'}>

        {/* Breadcrumb */}
        <div className={'w-full justify-start mb-3'}>
          <Breadcrumb
            separator={'>'}
            items={breadcrumbItems}
            className={'lg:block hidden text-base text-primary-900'}
          />
        </div>

        {/* Product Section */}
        <div className={'flex lg:flex-row flex-col justify-center items-start max-w-6xl'}>

          {/* Images */}
          <div className={'lg:w-1/2 w-full lg:sticky top-4  mt-5'}>
            <ImageSection
              data={product}
              selectedColor={selectedColor}
            />
          </div>

          {/* Product Info */}
          <div className={'lg:w-1/2 w-full lg:pl-8 mt-5 lg:p-0 p-3'}>
            <ProductInformation
              data={product}
              selectedColor={selectedColor}
              setSelectedColor={setSelectedColor}
            />
          </div>
        </div>

        {/* Related Products */}
        {relatedProducts.length > 0 && (
          <div className={'w-full lg:mt-10 mt-5 lg:p-0 p-3'}>
            <RelatedProducts
              products={relatedProducts}
              currentProduct={product}
            />
          </div>
        )}

      </div>
    </div>
  );
};

export default ProductDetails;
